import ApiService from "@/services/api.service";

const STATUS_TYPE = {
  delivery: "delivery",
  pay: "pay",
  canceled: "canceled",
  draft: "draft",
  new_made: "new",
  partially_shipped: "partiallyShipped",
};

const getWarrantyCard = async (id, type) => {
  try {
    const response = await ApiService.get(`shipments/${id}/warranty-card/${type}`, {
      responseType: "blob",
    });

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const exportDraft = async (id, withDealerPrices = false) => {
  try {
    const response = await ApiService.post(
      `orders/${id}/export`,
      { withDealerPrices: withDealerPrices },
      {
        responseType: "blob",
      }
    );

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const orderUpdatePreview = async ({ id, products }) => {
  try {
    const response = await ApiService.patch(
      `orders/${id}/preview`,
      { products: products },
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

export { STATUS_TYPE, getWarrantyCard, exportDraft, orderUpdatePreview };
